import script from "./role.vue?vue&type=script&setup=true&lang=js"
export * from "./role.vue?vue&type=script&setup=true&lang=js"

import "./role.vue?vue&type=style&index=0&id=7ecf3c90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ecf3c90"]])

export default __exports__